export default "__VITE_ASSET__5afbb1b2__"